import classifieds from './classifieds'

export default { classifieds }
